import {SecureService} from "@/services/superclasses/secure-service";
import {PaUser} from "@/interfaces/pa-user";

const api = window.contextPath + '/rest/pa-users';

export class PaUserSecureService extends SecureService {

    public loadByPerson = async (): Promise<PaUser> => {
        return this.data(await this.get<PaUser>(`${api}/by-person`))
    }
}

export const paUserSecureService = new PaUserSecureService()